export const selectScenarioEntityIds = (state) => state.scenario.entityIds;
export const selectScenarioOptions = (state) => state.scenario.options;
export const selectFetchingScenarioOptions = (state) =>
  state.scenario.fetchingOptions;
export const selectFetchingScenarioEntityIds = (state) =>
  state.scenario.fetchingScenarioEntityIds;
export const selectFetchingSubmitScenarioEntities = (state) =>
  state.scenario.fetchingSubmitScenarioEntities;
export const selectFetchingDeleteScenarioEntities = (state) =>
  state.scenario.fetchingDeleteScenarioEntities;
export const selectFetchingScenarioState = (state) =>
  state.scenario.fetchingScenarioState;
export const selectInvestPlatform = (state) => state.scenario.investPlatform;
